// Shared status colors for Door/Site schedule facets, filters, and list cards.
export const CANVASSER_STATUS_COLORS = {
  checked_in: { class: "_green", color: "#33a02c" },
  not_checked_in: { class: "_red", color: "#e31a1c" },
  unscheduled: { class: "_grey", color: "#555555" },
  assigned: { class: "_blue", color: "#1f78b4" },
};

// [List of Canvassers] -> [List of Canvassers]
// Finds all of the canvassers that have a checked in status

export const findCheckedInCanvassers = (canvassers) => {
  let checkedInCanvassers = canvassers.filter((d) => d.status === "checked_in");
  return checkedInCanvassers;
};

// [List of Crews], Int -> [List of Crews]
// Finds the crews that are apart of the shift

export const findCrewsByShiftId = (crews, shiftId) => {
  let currentCrews = crews.filter((d) => d.shift === shiftId);
  return currentCrews;
};

// [List of Crews] -> [List of Canvassers]
// Finds all of the canvassers that are assigned to the crews in the list

export const findAssignedCanvassers = (crews) => {
  let assigned_canvassers = crews.reduce((r, d) => {
    let seats = d.routeseats || d.seats || [];

    seats.forEach((s) => {
      let id = s.canvasser_id || s.canvasser || 0;

      id && r.push(id);
    });
    return r;
  }, []);
  return assigned_canvassers;
};

// [List of Crews], Int -> [List of Canvassers]
// Finds all of the canvassers that are apart of the passed shift

export const findCanvassersAssignedToShift = (crews, shiftId) => {
  let currentCrews = findCrewsByShiftId(crews, shiftId);
  let assignedCanvassers = findAssignedCanvassers(currentCrews);
  return assignedCanvassers;
};

// When shiftId is null/undefined/"all", return assignees across every crew passed in.
export const findCanvassersAssignedForSelection = (crews, shiftId) => {
  if (shiftId == null || shiftId === "all") {
    return findAssignedCanvassers(crews);
  }
  return findCanvassersAssignedToShift(crews, shiftId);
};
